import { createAction, props } from '@ngrx/store';
import { IPolicyCompleteData } from './contracts.models';

export const setContract = createAction(
  '[Contracts] Set a specific Quotation or policy from contracts',
  props<{ contractSelected: IPolicyCompleteData }>()
);

export const resetContract = createAction('[Contracts] Reset contracts');
